import { EMableEventName } from '@/core/constants/event_types/events';

import { CustomPixelStdEventName } from './cpx_payload_types';

export type ExcludedCustomPixelEvents =
  CustomPixelStdEventName.SEARCH_SUBMITTED;
export const ExcludedCustomPixelEventsList: ExcludedCustomPixelEvents[] = [
  CustomPixelStdEventName.SEARCH_SUBMITTED,
];
export type SupportedCustomPixelEvents = Exclude<
  CustomPixelStdEventName,
  ExcludedCustomPixelEvents
>;
export const cpxPixelNameToEventNameMapping: Record<
  SupportedCustomPixelEvents,
  EMableEventName
> = {
  [CustomPixelStdEventName.CART_VIEWED]: EMableEventName.CUSTOM_EVENT,
  [CustomPixelStdEventName.CHECKOUT_ADDRESS_INFO_SUBMITTED]:
    EMableEventName.CUSTOM_EVENT,
  [CustomPixelStdEventName.CHECKOUT_COMPLETED]: EMableEventName.ORDER_COMPLETED,
  [CustomPixelStdEventName.CHECKOUT_CONTACT_INFO_SUBMITTED]:
    EMableEventName.CUSTOM_EVENT,
  [CustomPixelStdEventName.CHECKOUT_SHIPPING_INFO_SUBMITTED]:
    EMableEventName.CUSTOM_EVENT,
  [CustomPixelStdEventName.CHECKOUT_STARTED]: EMableEventName.CHECKOUT_STARTED,
  [CustomPixelStdEventName.COLLECTION_VIEWED]:
    EMableEventName.COLLECTION_VIEWED,
  [CustomPixelStdEventName.PAGE_VIEWED]: EMableEventName.PAGE_VIEWED,
  [CustomPixelStdEventName.PAYMENT_INFO_SUBMITTED]:
    EMableEventName.PAYMENT_INFO_ADDED,
  [CustomPixelStdEventName.PRODUCT_ADDED_TO_CART]:
    EMableEventName.PRODUCT_ADDED,
  [CustomPixelStdEventName.PRODUCT_REMOVED_FROM_CART]:
    EMableEventName.CUSTOM_EVENT,
  [CustomPixelStdEventName.PRODUCT_VIEWED]: EMableEventName.PRODUCT_VIEWED,
  [CustomPixelStdEventName.UNKNOWN_EVENT]: EMableEventName.CUSTOM_EVENT,
};

export const cpxStandardEventNames = [
  CustomPixelStdEventName.CHECKOUT_COMPLETED,
  CustomPixelStdEventName.CHECKOUT_STARTED,
  CustomPixelStdEventName.COLLECTION_VIEWED,
  CustomPixelStdEventName.PAGE_VIEWED,
  CustomPixelStdEventName.PAYMENT_INFO_SUBMITTED,
  CustomPixelStdEventName.PRODUCT_ADDED_TO_CART,
  CustomPixelStdEventName.PRODUCT_VIEWED,
];
